<template>
    <div class="quick-view__wrapper" v-if="showModal && loadedItem">
        <div class="quick-view__backdrop" :class="{'modal-visible' : displayModal}"></div>
        <div class="quick-view__modal" :class="{'modal-visible' : displayModal}" tabindex="-1" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="quick-view__close" @click="closeQuickView()">
                            <svg width="18" height="18">
                                <use xlink:href="#svg_close" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                            </svg>
                        </div>
                        <div class="row">
                            <div class="col-7 left-side">
                                <item-image-carousel v-if="displayModal" :item-data="currentVariation" :plugin-path="pluginPathCeres"
                                                     image-url-accessor="url"></item-image-carousel>

                                <div class="widget widget-code widget-none mt-5">
                                    <div class="widget-inner bg-appearance">
                                        <div>
                                            <div class="single__features"
                                                 v-html="currentVariation.texts.shortDescription"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-5">
                                <div class="quick-view__right-side">

                                    <div class="widget widget-text widget-none title-outer m-0">
                                        <div class="widget-inner bg-appearance pt-0 pr-0 pb-0 pl-0">
                                            <h1 class="single__name"><span>{{ itemName }}</span></h1>
                                        </div>
                                    </div>

                                    <!-- hier waren single features -->

                                    <div class="widget widget-item-price widget-none single__prices">
                                        <item-price :item-data="currentVariation"
                                                    :show-cross-price="isRecommendedPriceActive"></item-price>
                                    </div>

                                    <div class="widget widget-code widget-none m-0">
                                        <div class="widget-inner bg-appearance pt-0 pr-0 pb-0 pl-0 mt-0 mr-0 mb-0 ml-0">
                                            <vat-component></vat-component>
                                            <!--<div class="single__vat">
                                                <a href="/weberbuero/versandkosten" target="_blank"
                                                   title="Versandkosten">
                                                    <span><span>+ 54,90&nbsp;€ Versandkosten</span>
                                                        <span>, 2. Artikel:  11,90 € pro Artikel im <b>Kombiversand</b></span>
                                                    </span>
                                                </a>
                                            </div>-->
                                        </div>
                                    </div>

                                    <template v-if="isConfActive">
                                        <wall-configurator
                                                :confi-article-list="confArticleList"
                                                :swiper-color-list="confColorIds"
                                                :conf-matrix="confMatrix"
                                                :item-data="currentVariation"
                                                :is-quick-view="true"
                                        ></wall-configurator>
                                    </template>
                                    <template v-else>
                                        <variation-cross-selling v-if="this.crossseller !== null && crossseller.length > 0"
                                                                 :item-data="currentVariation"
                                                                 :is-quick="true"
                                                                 :crossSellingItems="crossseller"></variation-cross-selling>
                                        <variation-select :item-data="currentVariation"></variation-select>
                                    </template>

									<div class="widget widget-grid widget-two-col row single__wishlist">
										<div class="widget-inner col-xl-9 widget-prop-xl-2-1 col-lg-9 widget-prop-lg-2-1 col-md-9 widget-prop-md-2-1 col-sm-12 widget-prop-sm-3-1 widget-stacked-mobile col-12 widget-prop-3-1 widget-stacked-mobile">
											<div>
												<div class="widget widget-add-to-basket widget-primary mt-3 mb-3">
													<add-to-basket
														:variation-id="currentVariation.variation.id"
														:is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
														:has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
														:interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
														:minimum-quantity="currentVariation.variation.minimumOrderQuantity"
														:maximum-quantity="!!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null"
														:order-properties="currentVariation.properties.filter(function(prop) { return prop.property.isOderProperty })"
														:use-large-scale="false"
														:show-quantity="true"
														origin="category"
														:item-data="currentVariation"
														:item-url="currentVariation | itemURL"
														:is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
														:has-price="currentVariation | hasItemDefaultPrice"
													>
													</add-to-basket>
												</div>
											</div>
										</div>
										<div class="widget-inner col-xl-3 widget-prop-xl-auto col-lg-3 widget-prop-lg-auto col-md-3 widget-prop-md-auto col-sm-12 widget-prop-sm-3-1 col-12 widget-prop-3-1">
											<div>
												<div class="widget widget-add-to-wish-list widget-none single__wishlist-btn">
													<add-to-wish-list
														:variation-id="currentVariation.variation.id"></add-to-wish-list>
												</div>
											</div>
										</div>
									</div>



                                    <a :href="currentVariation | itemURL" class="btn w-100 quick-view__goto-item">{{
                                        $translate("Weberbuero::Template.quickViewDetails") }}</a>

<!--                                    <div class="single__stock-availability" :class="'single__stock-availability_' + currentVariation.variation.availability.id">-->
<!--                                        <div class="single__stock" v-if="((currentVariation.variation.isMain && !currentVariation.filter.hasActiveChildren) || (!currentVariation.variation.isMain && !currentVariation.filter.hasActiveChildren)) && currentVariation.stock.net > 0 && currentVariation.variation.availability.id === 1" v-html="currentVariation.stock.net + $translate('Weberbuero::Template.quickViewDeliveryStock')"></div>-->
<!--                                        <div class="single__availability" v-if="currentVariation.variation.availability"-->
<!--                                             v-html="$translate('Weberbuero::Template.quickViewDelivery1') + currentVariation.variation.availability.names.name + (currentVariation.variation.availability.id === 1 ? 'n' : '') + $translate('Weberbuero::Template.quickViewDelivery2')"></div>-->
<!--                                    </div>-->

                                    <availability></availability>

                                    <!--<div class="single__stock-availability"
                                         :class="'single__stock-availability_' + currentVariation.variation.availability.id">
                                        <div class="single__availability">{{
                                            currentVariation.variation.availability.names.name }}
                                        </div>
                                    </div>-->

                                    <div class="widget widget-grid widget-two-col row single__wishlist">
                                        <div class="widget-inner col-xl-12 widget-prop-xl-auto col-lg-12 widget-prop-lg-auto col-md-12 widget-prop-md-3-1 col-sm-12 widget-prop-sm-3-1 widget-stacked-mobile col-12 widget-prop-3-1 widget-stacked-mobile">
                                            <div>
                                                <div class="widget widget-text widget-none single__article-number m-0">
                                                    <div class="widget-inner bg-appearance pt-0 pr-0 pb-0 pl-0 mt-0 mr-0 mb-0 ml-0">
                                                        <p>{{ $translate("Weberbuero::Template.singleItemId") }}: <span>{{ currentVariation.item.id }}</span>
                                                        </p></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="widget widget-code widget-none mb-0">
                                        <div class="widget-inner bg-appearance">
                                            <div class="text-center widget widget-d2g widget-payment-icons">
                                                <div class="widget-inner">
                                                    <ul class="list-unstyled d-flex flex-wrap justify-content-start icon-size-s">
                                                        <li class="amazon-pay"><img
                                                                src="https://bilder.weberbuero.de/frontend/images/shop/amazon-pay.svg"
                                                                alt="Amazon Pay - Zahlen Sie mit Ihrem Amazon-Account"
                                                                title="Amazon Pay - Zahlen Sie mit Ihrem Amazon-Account">
                                                        </li>
                                                        <li class="paypal"><img
                                                                src="https://bilder.weberbuero.de/frontend/images/shop/paypal.svg"
                                                                alt="PayPal" title="PayPal"></li>
                                                        <li class="visa"><img
                                                                src="https://bilder.weberbuero.de/frontend/images/shop/visa.svg"
                                                                alt="VISA" title="VISA"></li>
                                                        <li class="mastercard"><img
                                                                src="https://bilder.weberbuero.de/frontend/images/shop/mastercard.svg"
                                                                alt="Mastercard" title="Mastercard"></li>
                                                        <li class="invoice"><img
                                                                src="https://bilder.weberbuero.de/frontend/images/shop/Rechnungskauf_1.svg"
                                                                alt="Rechnungskauf nach Freischaltung"
                                                                title="Rechnung nach Freischaltung"></li>
                                                        <li class="american-express"><img
                                                                src="https://bilder.weberbuero.de/frontend/images/shop/american-express.svg"
                                                                alt="American Express" title="American Express"></li>
                                                        <li class="sepa-directdebit"><img
                                                                src="https://bilder.weberbuero.de/frontend/images/shop/sepa.svg"
                                                                alt="SEPA Lastschrift" title="SEPA Lastschrift"></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import { get } from "ceres/app/helper/get";
    import ApiService from "ceres/app/services/ApiService";
    import Swiper from "swiper";

    export default {
        created()
        {

        },

        mounted()
        {
            this.$nextTick(() =>
            {

            });
        },

        data()
        {
            return {
                showModal: false,
                loadedItem: false,
                item: null,
                isConfActive: false,
                confArticleList: [],
                displayModal: false
            };
        },

        methods: {
            initItem()
            {
                this.showModal = true;
                let _this = this;

                if (!this.$store.getters[`${this.itemId}/currentItemVariation`])
                {
                    ApiService.get(window.location.origin + "/rest/weberbuero/quickview?itemId=" + this.itemId + "&variationId=" + this.variationId)
                        .done(data =>
                        {

                            this.$store.dispatch("initVariation", data.item);

                            this.item = data.item.documents[0].data;

                            this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, 0);
                            this.$store.dispatch("addLastSeenItem", this.variationId);

                            this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
                                itemId: this.itemId,
                                attributes: data.variationAttributeMap.attributes,
                                variations: data.variationAttributeMap.variations,
                                initialVariationId: this.variationId,
                                isPleaseSelectOption: 0,
                                afterKey: {}
                            });

                            this.$store.commit("setQuickViewAttributes", { [this.itemId]: data.variationAttributeMap.attributes });
                            this.$store.commit("setQuickViewVariations", { [this.itemId]: data.variationAttributeMap.variations });

                            this.loadedItem = true;

                            setTimeout(function()
                            {
                                //$(".quick-view__modal").modal("show");
                                _this.displayModal = true;

                                // INFO: Alt-Last Jquery aus SingleItem
                                if ($('.single__features').length) {
                                    $('.single__features li').prepend('<svg width="8" height="12"><use xlink:href="#svg_arrow" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg>');
                                }
                                _this.initCrossSwiper();
                                _this.fillConfArticleList();
                                document.querySelector("body").classList.remove("loading-quickview");
                            }, 250);

                        }).fail((err) => console.log(err));
                }
                else
                {

                    this.$store.dispatch(`${this.itemId}/loadVariation`, this.variationId).then(variation =>
                    {
                        document.dispatchEvent(new CustomEvent("onVariationChanged",
                            {
                                detail:
                                    {
                                        attributes: variation.attributes,
                                        documents: variation.documents
                                    },
                                itemId: this.itemId
                            }));

                        this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, 0);
                        this.$store.dispatch("addLastSeenItem", this.currentVariation.variation.id);

                        let attributes = [];
                        for (let key in this.attributes)
                        {
                            for (let innerKey in this.attributes[key])
                            {
                                if (parseInt(innerKey) === this.itemId)
                                {
                                    attributes = this.attributes[key][innerKey];
                                    break;
                                }
                            }
                        }

                        let variations = [];
                        for (let key in this.variations)
                        {
                            for (let innerKey in this.variations[key])
                            {
                                if (parseInt(innerKey) === this.itemId)
                                {
                                    variations = this.variations[key][innerKey];
                                    break;
                                }
                            }
                        }

                        this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
                            itemId: this.itemId,
                            attributes: attributes,
                            variations: variations,
                            initialVariationId: this.variationId,
                            isPleaseSelectOption: 0
                        }).then(response =>
                        {

                        });
                    });

                    this.loadedItem = true;
                    setTimeout(function()
                    {
                        //$(".quick-view__modal").modal("show");
                        _this.displayModal = true;

                        // INFO: Alt-Last Jquery aus SingleItem
                        if ($('.single__features').length) {
                            $('.single__features li').prepend('<svg width="8" height="12"><use xlink:href="#svg_arrow" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg>');
                        }
                        _this.initCrossSwiper();
                        _this.fillConfArticleList();
                        document.querySelector("body").classList.remove("loading-quickview");
                    }, 250);
                }
            },

            closeQuickView()
            {
                this.$store.dispatch("removeItem", this.currentVariation);

                window.driftzoom.destroy();
                this.showModal = false;
                this.loadedItem = false;
                this.isConfActive = false;
                this.displayModal = false;

                this.$store.commit("setQuickViewItemId", 0);
                this.$store.commit("setQuickViewVariationId", 0);
                this.$store.commit("setQuickViewCrossseller", []);
            },

            initCrossSwiper()
            {
                if (this.loadedItem && this.crossseller !== null && this.crossseller.length > 0)
                {

                    var swipeVariations = new Swiper(".single-variations-swiper", {
                        navigation: {
                            nextEl: ".swiper-button-next-variations",
                            prevEl: ".swiper-button-prev-variations"
                        },
                        spaceBetween: 5,
                        loop: false,
                        slidesPerView: 4,
                        centeredSlides: false,
                        breakpointsInverse: true,
                        breakpoints: {
                            991: {
                                allowTouchMove: false,
                                slidesPerView: 5
                            }
                        }
                    });
                }
            },

            fillConfArticleList(){

                let confArticleList = [];
                let lastOuterLoop = false;
                let lastInnerLoop = false;
                let _this = this;

                for(let key in this.confMatrix){
                    let confIds = this.confMatrix[key].toString();
                    confIds = confIds.split(",");
                    let reqCounter = 0;

                    if(this.confMatrix.length === parseInt(key)+1){
                        lastOuterLoop = true;
                    }

                    if(confIds.indexOf(this.currentVariation.item.id+"") > -1){
                        // this.isConfActive = true;
                        for(let innerKey in confIds){
                            if(this.currentVariation.item.id == confIds[innerKey]){

                                reqCounter++;

                                if(confIds.length === reqCounter){
                                    lastInnerLoop = true;
                                }

                                confArticleList.push({data: this.currentVariation, id: this.currentVariation.variation.id});

                                if(lastInnerLoop && lastOuterLoop){
                                    _this.confArticleList = confArticleList;
                                    _this.isConfActive = true;
                                }
                            }else{
                                let response = new Promise((resolve, reject) =>
                                {
                                    ApiService.get(window.location.origin + "/rest/weberbuero/getItem?itemId=" + confIds[innerKey], { supressNotifications: true })
                                        .done(data =>
                                        {
                                            reqCounter++;
                                            if (data)
                                            {
                                                resolve(data);
                                            }
                                            else
                                            {
                                                reject();
                                            }

                                            if(confIds.length === reqCounter){
                                                lastInnerLoop = true;
                                            }

                                            confArticleList.push(data.documents[0]);

                                            if(lastInnerLoop && lastOuterLoop){
                                                _this.confArticleList = confArticleList;
                                                _this.isConfActive = true;
                                            }

                                        }).fail((err) => console.log(err));
                                });
                            }
                        }
                    }
                }

            }
        },

        watch: {
            itemId(value, oldValue)
            {
                if (value !== oldValue && value !== 0)
                {
                    this.initItem();
                }
            }
        },

        computed: {
            isRecommendedPriceActive()
            {
                return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
            },

            itemName(){
                return this.currentVariation && this.currentVariation.texts[0] ? this.currentVariation.texts[0].name1 : this.currentVariation.texts.name1;
            },

            currentVariationSelect()
            {
                return this.$store.state.items[this.itemId] && this.$store.state.items[this.itemId].variationSelect;
            },

            attributesToCheck()
            {
                return this.currentVariationSelect && this.currentVariationSelect.attributes;
            },

            pluginPathCeres()
            {
                return App.pluginPathCeres;
            },

            currentVariation()
            {
                return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
            },

            isVariationSelected()
            {
                if (this.loadedItem)
                {
                    return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
                }
                else
                {
                    return false;
                }
            },

            confMatrix(){

                if(App.weberConfig.confiItemIdsString !== ""){
                    //let confiItemIds = JSON.parse(App.weberConfig.confiItemIds);
                    let confiItemIdsString = App.weberConfig.confiItemIdsString;
                    confiItemIdsString = confiItemIdsString.split("#");

                    for(let key in confiItemIdsString){
                        confiItemIdsString[key] = confiItemIdsString[key].split(",");
                    }

                    return confiItemIdsString;
                }

                return [
                    [3256,2613],
                    [2607,3262],
                    [3258,2612],
                    [3264,2606],
                    [3261,2611],
                    [3267,2605],
                    [3257,2610],
                    [3263,2604],
                    [3260,2609],
                    [3266,2603],
                    [3259,2608],
                    [3265,2602],
                    [4802,4803],
                    [1426,4811,4812],
                    [1758],
                    [1428,4813,4814],
                    [1759,4827,4826],
                    [2202],
                    [1749],
                    [1913],
                    [2432,2433,1425],
                    [2958,2957],
                    [2203],
                    [2961,4962],
                    [2253],
                    [4977,4976],
                    [2861],
                    [2964,4968]
                ]
            },

            confColorIds(){
                return App.weberConfig.confiColorIds.split(",");
            },

            ...mapState({
                itemId: state => state.quickview.itemId,
                variationId: state => state.quickview.variationId,
                crossseller: state => state.quickview.crossseller,
                attributes: state => state.quickview.attributes,
                variations: state => state.quickview.variations
            })
        }
    };
</script>
